/* Vanashree Organics - carousels, Quick View, personalised recommendations, home SEO copy reveal */
(function () {
  'use strict';
  var d = document;
  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- Global cart-count sync (app-agnostic) ----------
     Kept as defense-in-depth: watches for ANY request - ours or any other app's - to a cart-mutating
     Shopify endpoint, then re-fetches /cart.js and writes the real item_count into every header bubble
     on the page. Dawn's own product-form.js (used by both the real PDP button and, as of 3 Oct 2026,
     Quick View too) already updates the cart-icon-bubble section itself on a successful add, so this is
     now a safety net rather than the primary mechanism. */
  var CART_MUTATE_RE = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;
  var syncTimer = null;
  function syncCartBubble() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          qsa('.cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = c.item_count; });
          d.dispatchEvent(new CustomEvent('vo:cart-synced', { detail: c }));
        }).catch(function () {});
    }, 150); /* short debounce: coalesce bursts of parallel cart requests into one refresh */
  }
  (function patchFetch() {
    if (!window.fetch || window.fetch.__voPatched) return;
    var orig = window.fetch;
    var patched = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (CART_MUTATE_RE.test(url)) p.then(syncCartBubble, function () {});
      return p;
    };
    patched.__voPatched = true;
    window.fetch = patched;
  })();
  (function patchXHR() {
    try {
      var P = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
      if (!P || P.__voPatched) return;
      var origOpen = P.open;
      P.open = function (method, url) {
        try {
          if (CART_MUTATE_RE.test(url || '')) this.addEventListener('loadend', syncCartBubble);
        } catch (err) {}
        return origOpen.apply(this, arguments);
      };
      P.__voPatched = true;
    } catch (err) {}
  })();

  /* ---------- Shared carousel: arrows, disabled state, drag (mouse), native swipe (touch) ---------- */
  function initCar(root) {
    if (!root || root.__voCar) return;
    var track = qs('[data-track]', root);
    if (!track) return;
    root.__voCar = true;
    var prev = qs('[data-dir="prev"]', root), next = qs('[data-dir="next"]', root);
    function step() {
      var it = track.children[0];
      if (!it) return 240;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return it.getBoundingClientRect().width + gap;
    }
    function upd() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('vo-car--static', max <= 0);
    }
    root.__voCarUpdate = upd;
    function go(dir) {
      var s = step(), per = Math.max(1, Math.floor(track.clientWidth / s));
      track.scrollBy({ left: dir * s * per, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; upd(); });
    }, { passive: true });
    window.addEventListener('resize', upd);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); }
    });
    /* mouse drag */
    var down = false, moved = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('button, input, select, textarea, form')) return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-drag'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    function end() { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-drag'); }, 0); }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    upd();
    setTimeout(upd, 300); setTimeout(upd, 1200);
    qsa('img', track).forEach(function (im) { if (!im.complete) im.addEventListener('load', upd, { once: true }); });
  }

  /* ---------- Quick View ---------- */
  var qv, qvContent, qvTrigger, qvCache = {};
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function buildQV() {
    if (qv) return;
    qv = d.createElement('div');
    qv.className = 'vo-qv';
    qv.hidden = true;
    qv.setAttribute('role', 'dialog');
    qv.setAttribute('aria-modal', 'true');
    qv.setAttribute('aria-label', 'Product quick view');
    qv.innerHTML = '<div class="vo-qv__overlay" data-qv-close></div><div class="vo-qv__dialog" tabindex="-1"><button type="button" class="vo-qv__close" data-qv-close aria-label="Close quick view">' + CLOSE_SVG + '</button><div class="vo-qv__content"></div></div>';
    d.body.appendChild(qv);
    qvContent = qs('.vo-qv__content', qv);
    qv.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) closeQV(); });
    qv.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeQV(); return; }
      if (e.key !== 'Tab') return;
      var f = qsa('button:not([disabled]), a[href], input, select, textarea', qs('.vo-qv__dialog', qv)).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && d.activeElement === last) { first.focus(); e.preventDefault(); }
    });
  }
  function closeQV() {
    if (!qv || qv.hidden) return;
    qv.hidden = true;
    d.body.classList.remove('vo-qv-lock');
    if (qvTrigger && qvTrigger.focus) { try { qvTrigger.focus(); } catch (e) {} }
  }
  /* Close Quick View automatically once Dawn's real product-form.js (now used by the Quick View
     button too, see product.quick.liquid) reports a successful add-to-cart. This replaces the old
     custom fetch handler's own close-on-success logic. */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'product-form' && qv && !qv.hidden) {
          closeQV();
        }
      });
    }
  } catch (e) {}
  function openQV(url, trigger) {
    buildQV();
    qvTrigger = trigger;
    qvContent.innerHTML = '<div class="vo-qv__loading"><i></i></div>';
    qv.hidden = false;
    d.body.classList.add('vo-qv-lock');
    var dlg = qs('.vo-qv__dialog', qv); dlg.scrollTop = 0; dlg.focus();
    var u = url.split('#')[0]; u += (u.indexOf('?') > -1 ? '&' : '?') + 'view=quick';
    var p = qvCache[u] ? Promise.resolve(qvCache[u]) : fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('x'); return r.text(); });
    p.then(function (html) {
      qvCache[u] = html;
      if (qv.hidden) return;
      qvContent.innerHTML = html;
      initQVProduct(qs('.vo-qvp', qvContent), url);
      try { if (window.jdgm && window.jdgm.customizeBadges) window.jdgm.customizeBadges(); } catch (e) {}
    }).catch(function () { location.href = url; });
  }
  function fmtMoney(cents, fmt) {
    var a = cents / 100;
    var noDec = Math.round(a).toLocaleString('en-IN');
    var dec = a.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (fmt || 'Rs. {{amount}}').replace(/<[^>]+>/g, '')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec)
      .replace(/\{\{\s*amount\s*\}\}/, dec);
  }
  /* 2026-10-03: initQVProduct no longer owns Add to Cart submission. It only wires up the thumbnail
     gallery, quantity stepper, and variant-option UI (keeping the hidden id field + displayed price in
     sync as the shopper picks options). Submitting the form, showing the loading spinner, handling
     errors, and updating the cart is now entirely Dawn's real product-form.js - the same code path the
     working PDP button already uses - via the <product-form> element product.quick.liquid renders. */
  function initQVProduct(root, url) {
    if (!root) return;
    var variants = [];
    try { variants = JSON.parse(qs('[data-qv-variants]', root).textContent); } catch (e) {}
    var fmt = root.getAttribute('data-money-format');
    var main = qs('[data-qv-main]', root);
    var atc = qs('[data-qv-atc]', root), qty = qs('[data-qv-qty]', root);
    var hiddenId = qs('input[name="id"]', root);
    var cur = variants[0];
    function selected() {
      var vals = [];
      qsa('.vo-qvp__opt', root).forEach(function (fs) { var c = qs('input:checked', fs); vals.push(c ? c.value : null); });
      return vals;
    }
    function match() {
      var vals = selected();
      if (!vals.length) return variants[0];
      return variants.filter(function (v) { return vals.every(function (val, i) { return v.options[i] === val; }); })[0];
    }
    function render() {
      cur = match();
      var priceEl = qs('[data-qv-price]', root), was = qs('[data-qv-was]', root), off = qs('[data-qv-off]', root);
      if (!cur) { atc.disabled = true; qs('span', atc).textContent = 'Unavailable'; return; }
      if (hiddenId) hiddenId.value = cur.id;
      priceEl.textContent = fmtMoney(cur.price, fmt);
      if (cur.compare_at_price && cur.compare_at_price > cur.price) {
        was.textContent = fmtMoney(cur.compare_at_price, fmt); was.hidden = false;
        off.textContent = '-' + Math.round((cur.compare_at_price - cur.price) * 100 / cur.compare_at_price) + '% Off'; off.hidden = false;
      } else { was.hidden = true; off.hidden = true; }
      atc.disabled = !cur.available;
      qs('span', atc).textContent = cur.available ? 'Add to Cart' : 'Sold Out';
      if (cur.featured_image && cur.featured_image.src && main) {
        var src = cur.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x900$1$2');
        main.src = src;
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.vo-qvp__opt')) render(); });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-qv-thumb]');
      if (t && main) {
        main.src = t.getAttribute('data-qv-thumb');
        qsa('.vo-qvp__thumb', root).forEach(function (x) { x.classList.toggle('is-active', x === t); });
      }
      if (e.target.closest('[data-qv-minus]')) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      if (e.target.closest('[data-qv-plus]')) qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1);
    });
    render();
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vo-qv]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    openQV(b.getAttribute('data-vo-qv'), b);
  }, true);

  /* ---------- Recently viewed + "Picked Just for You" ---------- */
  var KEY = 'vo_recent';
  function recent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveRecent() {
    try {
      if (!window.voProduct || !window.voProduct.id) return;
      var l = recent().filter(function (x) { return x !== window.voProduct.id; });
      l.unshift(window.voProduct.id);
      localStorage.setItem(KEY, JSON.stringify(l.slice(0, 10)));
    } catch (e) {}
  }
  function initPicked(root) {
    var ids = recent();
    if (!root || !ids.length) return;
    var section = root.getAttribute('data-recs-section'), track = qs('[data-track]', root), sub = qs('[data-vo-picked-sub]', root);
    function fetchRecs(i) {
      if (i >= Math.min(ids.length, 3)) return;
      fetch('/recommendations/products?section_id=' + section + '&product_id=' + ids[i] + '&limit=10&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = d.createElement('div'); tmp.innerHTML = html;
          var items = qsa('[data-vo-recs] > .vo-car__item', tmp);
          if (items.length < 4) { fetchRecs(i + 1); return; }
          track.innerHTML = '';
          items.forEach(function (it) { track.appendChild(it); });
          track.scrollLeft = 0;
          if (sub) sub.textContent = 'Based on products you viewed recently';
          if (root.__voCarUpdate) root.__voCarUpdate();
          try { if (window.jdgm && window.jdgm.customizeBadges) window.jdgm.customizeBadges(); } catch (e) {}
        }).catch(function () {});
    }
    fetchRecs(0);
  }

  /* ---------- Home SEO copy: collapsed visually, still in the DOM, reveal on hover / focus / tap ---------- */
  var SEO = [
    { desc: '[id$="__featured_collection_3QEM8Y"] .collection__description', head: '[id$="__custom_liquid_B3rjif"] h1' },
    { desc: '[id$="__featured_collection_Wfgdah"] .collection__description', head: '[id$="__featured_collection_Wfgdah"] .title' }
  ];
  function initSeo(cfg, idx) {
    var desc = qs(cfg.desc), head = qs(cfg.head);
    if (!desc || !head || desc.__voSeo) return;
    desc.__voSeo = true;
    var host = desc.closest('.shopify-section') || desc.parentNode;
    host.classList.add('vo-seo-host');
    desc.id = desc.id || ('vo-seo-desc-' + idx);
    desc.classList.add('vo-seo-hidden');
    head.classList.add('vo-seo-trigger');
    if (!head.hasAttribute('tabindex')) head.setAttribute('tabindex', '0');
    head.setAttribute('aria-describedby', desc.id);
    var btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'vo-seo-info';
    btn.setAttribute('aria-label', 'Show more about this section');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', desc.id);
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M12 11v6M12 6.5v.5"/></svg>';
    head.appendChild(btn);
    var openT, closeT, isOpen = false;
    function place() {
      var hb = head.getBoundingClientRect(), ho = host.getBoundingClientRect();
      desc.style.top = Math.max(0, hb.bottom - ho.top + 6) + 'px';
    }
    function open() {
      clearTimeout(closeT);
      if (isOpen) return;
      isOpen = true;
      desc.classList.remove('vo-seo-hidden'); desc.classList.add('vo-seo-open');
      place(); btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      desc.classList.add('vo-seo-hidden'); desc.classList.remove('vo-seo-open');
      desc.style.top = ''; btn.setAttribute('aria-expanded', 'false');
    }
    function later() { clearTimeout(closeT); closeT = setTimeout(close, 250); }
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (canHover) {
      head.addEventListener('mouseenter', function () { clearTimeout(closeT); openT = setTimeout(open, 80); });
      head.addEventListener('mouseleave', function () { clearTimeout(openT); later(); });
      desc.addEventListener('mouseenter', function () { clearTimeout(closeT); });
      desc.addEventListener('mouseleave', later);
    }
    head.addEventListener('focus', open);
    head.addEventListener('blur', function () { setTimeout(function () { if (!head.contains(d.activeElement) && !desc.contains(d.activeElement)) close(); }, 0); });
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); isOpen ? close() : open(); });
    head.addEventListener('click', function (e) { if (!canHover && e.target !== btn) { isOpen ? close() : open(); } });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    d.addEventListener('click', function (e) { if (isOpen && !head.contains(e.target) && !desc.contains(e.target)) close(); });
    window.addEventListener('resize', function () { if (isOpen) place(); });
  }

  window.addEventListener('error', function (e) {
    try {
      var msg = (e && (e.message || (e.error && e.error.message))) || '';
      if (/whatmore/i.test(msg) || /ChunkLoadError/i.test(msg)) {
        e.stopImmediatePropagation();
      }
    } catch (err) {}
  }, true);

  ready(function () {
    qsa('[data-vo-car]').forEach(initCar);
    qsa('[data-vo-picked]').forEach(initPicked);
    SEO.forEach(initSeo);
    saveRecent();
  });
  d.addEventListener('shopify:section:load', function () { qsa('[data-vo-car]').forEach(initCar); SEO.forEach(initSeo); });
})();
